import { Flex, Text } from "@chakra-ui/react";
import { formatNumber } from "../../utils/utils";

// Mỗi phần tử là 1 ô thống kê (key = field trong summary backend trả về).
// Không dùng ô nào thì comment đúng dòng của ô đó, các ô còn lại tự dàn lại.
const STAT_BOXES = [
  { title: "Tổng người được giới thiệu", key: "referredCount" },
  { title: "Tổng tiền tạm tính", key: "provisionalAmount", isMoney: true },
  { title: "Tổng tiền thực nhận", key: "paidAmount", isMoney: true },
  { title: "Nguồn cá nhân", key: "personalSourceCount" },
  { title: "Nguồn công ty", key: "companySourceCount" },
  { title: "Nguồn chưa duyệt", key: "noSourceCount" },
];

// Khối ô thống kê, cùng kiểu với trang Quản lý nhân viên.
// Không dùng cả khối thì comment dòng <ReferralEarningStats ... /> ở bảng.
const ReferralEarningStats = ({ summary }) => (
  <Flex alignItems={"center"} gap={{ base: "16px" }} flexWrap={"wrap"}>
    {STAT_BOXES.map((item) => {
      const value = Number(summary?.[item.key]) || 0;

      return (
        <Flex
          minW={{ base: "192px" }}
          key={item.key}
          flexDirection={"column"}
          backgroundColor={"#FFF"}
          p={"16px 42px 16px 16px"}
          borderRadius={{ base: "12px" }}
          gap={{ base: "12px" }}
        >
          <Text
            fontSize={{ base: "15px" }}
            fontWeight={400}
            color="var(--text-color-Subtittle)"
          >
            {item.title}
          </Text>
          <Text fontSize={{ base: "20px" }} fontWeight={500} color={"#000"}>
            {item.isMoney ? `${formatNumber(value)} VNĐ` : value}
          </Text>
        </Flex>
      );
    })}
  </Flex>
);

export default ReferralEarningStats;
